export default "/wind_dir.defc14a7-c5912c.svg";